import { AsteriskSVG, ElectricBoltSVG } from "../../../../assets";
import { BulletList } from "./BulletList";

interface Props {
  riskAssessmentData: {
    shortTermRisks: string[];
    longTermRisks: string[];
  };
}

export const RiskAssessment = ({ riskAssessmentData }: Props) => {
  if (!riskAssessmentData) return <></>;
  return (
    <div className="flex gap-2 flex-col sm:flex-row">
      <BulletList
        title="Short-term Risks"
        premium
        icon={<ElectricBoltSVG />}
        list={riskAssessmentData.shortTermRisks.map((item) => ({ text: item }))}
      />
      <BulletList
        premium
        title="Long-term Risks"
        icon={<AsteriskSVG />}
        list={riskAssessmentData.longTermRisks.map((item) => ({ text: item }))}
      />
    </div>
  );
};
